import React, { useContext, useEffect } from "react";
import Add_Money from "./add-money/Add_Money";
import Subscription_Plan from "./subscription-plan/Subscription_Plan";
import Wallet_History from "./wallet-history/Wallet_History";
import { UserWalletHistory } from "../../../features/admin/subscription/Slice";
import { useDispatch, useSelector } from "react-redux";
import { Context } from "../../../utils/context";

function Wallet() {
  const dispatch = useDispatch();
  const { userdata } = useContext(Context);

  const subscriptionHistory = useSelector(
    (state) => state?.subscription?.subscriptions?.history,
  );

  useEffect(() => {
    dispatch(UserWalletHistory());
  }, [dispatch]);
  return (
    <>
      <Add_Money />
      <Subscription_Plan />
      <Wallet_History subscriptionHistory={subscriptionHistory} />
    </>
  );
}

export default Wallet;
